const style = {
  containerCard: {
    backgroundColor: 'transparent',
    border: '1px solid #E3E3E3',
    borderRadius: '4px',
  },
  containerCardsBox: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
  skeleton: {
    width: '33%',
    height: 85,
    variant: 'rectangular',
    sx: { m: '20px' },
  },
  icon: {
    viewBox: '0 0 20 20',
    sx: {
      '& svg': {
        height: 20,
        width: 20,
      },
    },
  },
} as const;

export default style;
